import AuthenticatedRoute from 'eflex/util/authenticated-route';

export default class PartsRoute extends AuthenticatedRoute {}
